import styled from 'styled-components';
import icCameraWhite from '../../../../assets/icons/ic_camera_white.svg';

import colors from '../../../../constants/colors';

import Button from '../../../Button';

const Wrapper = styled.div`
  flex-shrink: 0;
  width: 400px;

  @media screen and (max-width: 992px) {
    padding: 10px 20px 60px 20px;
    width: 100%;

    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      height: 10px;
      background: ${colors.main.dividers};
    }
  }
`;

const AvatarImageEdit = styled.div`
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  z-index: 10;

  &:before {
    content: '';
    display: block;
    background: url(${icCameraWhite}) 50% 50% no-repeat;
    margin: 0 auto 5px;
    height: 40px;
    width: 40px;
  }
`;

const AvatarImage = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${colors.main.blue};
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  position: relative;
  filter: blur(3px);

  &:after {
    background: ${colors.main.blue};
    opacity: 0.21;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  @media screen and (max-width: 992px) {
    position: static;
    left: 0;
    width: 100px;
    height: 100px;
    margin: 0 auto;
  }
`;

const Avatar = styled.label`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  color: white;
  background-color: #0ea0c;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  margin: 70px auto 30px auto;
  box-shadow: 0 15px 30px #eaeaea;
  position: relative;

  @media screen and (max-width: 992px) {
    box-shadow: none;
    position: relative;
    left: 0;
    width: 100px;
    height: 100px;
    margin: 20px auto 0 auto;
  }
`;

const AvatarInput = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
`;

const InformationBlock = styled.div`
  margin: 45px auto 0 auto;
  text-align: center;
  position: relative;
  width: 320px;

  @media screen and (max-width: 992px) {
    position: static;
    left: 0;
    margin: 20px auto 0 auto;
    width: 100%;
  }
`;

const Fieldset = styled.fieldset`
  div {
    &:nth-of-type(3) {
      z-index: 2;
    }

    &:nth-of-type(4) {
      z-index: 1;
    }
  }
`;

const animatedValues = `
  position: relative;
`;

const SaveButton = styled(Button)`
  margin-bottom: 20px;
  ${animatedValues}

  ${(props) => (props.isEmailChanged ? 'transform: translateY(0)' : null)};

  @media screen and (max-width: 992px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 60px;
    border-radius: 0;
    z-index: 1000;
    margin: 0;
  }
`;

const AnimatatedField = styled.div`
  ${animatedValues}

  ${(props) => (props.isEmailChanged ? 'transform: translateY(0)' : null)};
`;

export {
  AvatarImageEdit,
  AvatarImage,
  AvatarInput,
  Wrapper,
  Avatar,
  InformationBlock,
  Fieldset,
  SaveButton,
  AnimatatedField,
};
